import { dataAtom, dataComposer } from "@frend-digital/centra-legacy";

import type { CentraProduct } from "../atomicSetup";
import { baseAtomics } from "../atomicSetup";
import {
  getAvailability,
  getComingSoon,
  getFaq,
  getFitAdvice,
  getGender,
  getLabels,
  getMaterialCare,
  getMedia,
  getModelDisclaimer,
  getShortDesc,
  getSizeGuide,
  getSpecs,
  getSwatch,
} from "../localAtomics";
import getProductGallery from "./formatProductCards/getGallery";
const {
  getDisplayPriceWithSale,
  getName,
  getUri,
  getProductBreadcrumbs,
  getVariantName,
  getProduct,
  getSku,
  getProductSizes,
  getDescriptionHtml,
} = baseAtomics;

export const formatVariant = (product: CentraProduct) => {
  const name = dataAtom(getName, 2)(product);
  const itemId = dataAtom(getProduct, 2)(product);
  const variantName = dataAtom(getVariantName, 2)(product);
  const breadcrumbs = dataAtom(getProductBreadcrumbs, 2)(product);
  const prices = dataAtom(getDisplayPriceWithSale, 2)(product);
  const uri = dataAtom(getUri, 2)(product);
  const description = dataAtom(getDescriptionHtml, 2)(product);
  const shortDescription = dataAtom(getShortDesc, 2)(product);
  const sku = dataAtom(getSku, 2)(product);
  const sizes = dataAtom(getProductSizes, 2)(product);
  const media = dataAtom(getMedia, 2)(product);
  const gender = dataAtom(getGender, 2)(product);
  const sizeguide = dataAtom(getSizeGuide, 2)(product);
  const faq = dataAtom(getFaq, 2)(product);
  const specs = dataAtom(getSpecs, 2)(product);
  const comingSoon = dataAtom(getComingSoon, 2)(product);
  const labels = dataAtom(getLabels, 2)(product);
  const swatch = dataAtom(getSwatch, 2)(product);
  const gallery = getProductGallery(product);
  const availability = dataAtom(getAvailability, 2)(product);
  const modelDisclaimer = dataAtom(getModelDisclaimer, 2)(product);
  const fitAdvice = dataAtom(getFitAdvice, 2)(product);
  const materialCare = dataAtom(getMaterialCare, 2)(product);

  return dataComposer({
    name,
    breadcrumbs,
    variantName,
    prices,
    uri,
    itemId,
    media,
    description,
    shortDescription,
    sku,
    sizes,
    sizeguide,
    specs,
    gallery,
    labels,
    swatch,
    availability,
    modelDisclaimer,
    materialCare,
    fitAdvice,
    gender,
    faq,
    comingSoon,
  });
};

export type VariantType = ReturnType<typeof formatVariant>;
